export const public_api = {
  api: {
    regions: '/regions',
    cities: '/cities',
    // getDoctor: '/exclusive',
    getDoctor: '/exclusive2',
    previsions: '/previsions',
    boxes: '/boxes',
    filter: {
      doctor: '/filter/doctor',
      doctornew: '/filter/doctor/paginate'
    },
    speciality: {
      list: '/specialities'
    },
    diary: {
      getHours: '/diary/getHoursAvailable'
    },
    patient: {
      store: '/patient/register2'
    },
    type_patients: '/type_patients',
    integrations: "/integrations"
  }
}

export const doctor = {
  api: {
    lang: {
      enabled: '/language',
      set: '/language/set',
      trans: '/language/translate'
    },
    register: '/doctor/register',
    exists: '/doctor/exists',
    upload: {
      avatar: '/doctor/avatar',
      office: '/doctor/upload/office',
      subordinate: '/doctor/upload/subordinate'
    },
    list: {
      doctor: '/doctor/doctor',
      office: '/doctor/offices'
    },
    patient: {
      exists: '/patient/exists'
    },
    diary: {
      store: '/diary',
      update: '/diary/'
    },
    reserve: {
      store: '/reserve'
    },
    comunities: '/doctor/comunities',
    regions: '/doctor/regions',
    offices: '/doctor/offices',
    schedules: '/doctor/schedules',
    turns: '/doctor/schedules/turn',
    extraHours: '/doctor/extra-hours',
    absences: '/doctor/absences',
    search: '/doctor/search',
    tracking: '/doctor/tracking',
    subordinates: '/doctor/subordinates',
    roles: '/doctor/roles',
    bids: '/doctor/bids'
  }
}

export const prefix = ['cl', 'pe', 'ar','mx','co','es', 'us', 'bo', 've', 'do', 'cr'];

export const patient = {
  api: {
    profile: '/patient/update',
    exists: '/patient/exists',
    global_search: '/patient/search/global',
    global_bonus_tasks: '/patient/bonus_tasks/global',
    global_bonuses: '/patient/bonuses/global',
  }
}



// WEBPACK FOOTER //
// ./src/config/api.js